import { strip } from '@/utils/validate-cnpj';

export default {
  cnpj(state) {
    return state.cnpj;
  },
  rawCnpj(state) {
    return strip(state.cnpj);
  },
  empresa(state) {
    return state.empresa;
  },
};
